<template>
  <div class="home">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: "Home",
     components: {},
    watch: {},
    data() {
        return {
            open: true,

        };
    },
    computed: {

    },
    mounted() {
        
    },
    methods: {},

    async created() {
        let userParams = await this.$auth.getUserParams();
        if (userParams == null || userParams.accessToken == null) {
            await this.$router.push({
                name: "Login"
            });
        }
    },
};
</script>
